import Component from '../abstracts/Component';

export default class DropdownComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-dropdown',
      dropdownToggle: '.dropdown-toggle',
      close: '.js-close-layer',
      generic: '.dropdown'

    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
    this.mainTarget = $(this.SELECTORS.main);
  }


  //for desktop
  desktopBehaviour() {
    let ctx = this;
    this.$on('mouseover.dropdown', ({event}) => {

      ctx.$emit(ctx.$customEvents.DROPDOWN_EVENTS.open, {
        source: event.currentTarget,
        res: 'lg'
      });
    }, 'body', this.SELECTORS.main);

    this.$on('mouseleave.dropdown', ({event}) => {
      this.$emit(ctx.$customEvents.DROPDOWN_EVENTS.close, {
        source: event.currentTarget,
        res: 'lg'
      });

    }, 'body', this.SELECTORS.main);


    this.$on('keyup.dropdown', ({event}) => {
      if (event.which === 13) {
        const firstFocusable = this.$getFirstFocusable(event.currentTarget);
        this.toggleClasses(event.currentTarget);
        setTimeout(() => {
          firstFocusable.focus();
        }, 200)
      }
    }, 'body', this.SELECTORS.main);
  }

  toggleClasses(el) {

    let main = $(el).closest('.dropdown');
    if (!main.hasClass(this.CLASSES.show)) {
      this.forceClose();
      main.addClass(this.CLASSES.show);
    } else {
      main.removeClass(this.CLASSES.show);
    }

  }

  forceClose() {
    const main = document.querySelectorAll(this.SELECTORS.generic);
    main.forEach(el => el.classList.remove(this.CLASSES.show));
  }


  //for tablet
  tabletBehaviour() {
    this.$on('click.dropdown', ({event}) => {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
        source: event.currentTarget,
        res: 'md'
      });
    }, 'body', `${this.SELECTORS.main} ${this.SELECTORS.dropdownToggle}`);
  }

  // for mobile layers
  mobileBehaviour() {

    //riportata in questo modo altrimenti triggerava piu click - da capire perchè

    let ctx = this;

    $('body').on('click.dropdownMobile', `${this.SELECTORS.main} ${this.SELECTORS.dropdownToggle}`,  (e) => {
      const target = e.currentTarget;

      ctx.$emit(ctx.$customEvents.DROPDOWN_EVENTS.open, {
        source: target,
        res: 'sm'
      });

    })

  }

  bindEvents() {

    if (this.$matchMedia(null, 'lg')) {
      this.desktopBehaviour();
    } else if (this.$matchMedia('lg', 'sm')) {
      this.tabletBehaviour();
    } else {
      this.mobileBehaviour()
    }

    window.addEventListener('resize', () => {
      if (this.$matchMedia(null, 'lg')) {
        this.desktopBehaviour();
      } else if (this.$matchMedia('lg', 'sm')) {
        this.tabletBehaviour();
      } else {
        this.mobileBehaviour()
      }
    });

    this.$on(this.$customEvents.FILTERS_EVENTS.pageLoaded, () => {
      this.forceClose();
    });

    this.$on(`${this.$customEvents.KEYBOARD_EVENTS.escape}.dropdown`, () => {
      this.forceClose();
    });

    this.$on(this.$customEvents.DROPDOWN_EVENTS.open, ({event, payload}) => {

      let el = payload.source;

      switch (payload.res) {
        case 'lg':
          el.classList.add(this.CLASSES.show);
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.opened, el);
          break;
        case 'md':
          this.toggleClasses(el)
          break;
        case 'sm':
          if (el.dataset.modalDropdown) {
            let modalId = el.dataset.target;
            let modalHtml = document.querySelector(modalId).outerHTML;
            this.$emit(this.$customEvents.MODAL_EVENTS.show, {
              unsafeContent: modalHtml
            })
          } else {
            this.toggleClasses(el);
          }
          break;
      }

    });

    this.$on(this.$customEvents.DROPDOWN_EVENTS.close, ({event, payload}) => {

      let el = payload.source;

      switch (payload.res) {
        case 'lg':
          const input = el.querySelector('input:focus');
          if (!input) {
            el.classList.remove(this.CLASSES.show);
          }
          break;
      }

    });


  }

  render() {
    this.bindEvents();
  }
}
